import dictionary from 'config/dictionary';

export const DELIVERY_PHONE_HINT =
  dictionary.segments.formRedemption.phoneNumberHint;

const PHONE_LABEL = /\b(phone|mobile)\b/i;

/**
 * Adds an "i" tooltip hint to the phone-number field of a form-redemption
 * segment configuration, reassuring recipients that the number is only shared
 * with the courier.
 *
 * The phone field is detected by its stable `name` (`phoneNumber`) rather than
 * its display label, which is supplier-configurable and varies (e.g. "Number",
 * "Phone Number", "Mobile Number" on Shopify suppliers). `elementType` is also
 * checked to cover any legacy config stored as `phoneNumber`.
 *
 * Segments authored before cosmo normalised the field name can carry a
 * different `name` with a plain `string` element type, so a string field whose
 * label reads as a phone number is matched too. Only the string control renders
 * `info`, so other element types are left alone whatever they are labelled.
 *
 * Returns a new configuration; the input is never mutated. Configurations
 * without a phone field (or without `formDataTypes`) are returned untouched.
 */
export const addDeliveryPhoneHint = (configuration) => {
  const formDataTypes = configuration?.formDataTypes;
  if (!Array.isArray(formDataTypes)) {
    return configuration;
  }

  const isPhoneLabel = (field) =>
    PHONE_LABEL.test(field?.label ?? '') ||
    PHONE_LABEL.test(field?.placeholder ?? '');

  const isPhoneField = (field) =>
    field?.name === 'phoneNumber' ||
    field?.elementType === 'phoneNumber' ||
    (field?.elementType === 'string' && isPhoneLabel(field));

  if (!formDataTypes.some(isPhoneField)) {
    return configuration;
  }

  return {
    ...configuration,
    formDataTypes: formDataTypes.map((field) =>
      isPhoneField(field) ? { ...field, info: DELIVERY_PHONE_HINT } : field,
    ),
  };
};
